import React from 'react';
import { AlertCircle, RefreshCw } from 'lucide-react';

const ErrorMessage = ({
    title = "Erreur",
    message,
    onRetry,
    className = "",
    type = "error"
}) => {
    const typeStyles = {
        error: {
            bg: "bg-red-50",
            border: "border-red-200",
            icon: "text-red-500",
            title: "text-red-800",
            message: "text-red-700",
            button: "bg-red-500 hover:bg-red-600"
        },
        warning: {
            bg: "bg-amber-50",
            border: "border-amber-200",
            icon: "text-amber-500",
            title: "text-amber-800",
            message: "text-amber-700",
            button: "bg-amber-500 hover:bg-amber-600"
        },
        info: {
            bg: "bg-blue-50",
            border: "border-blue-200",
            icon: "text-blue-500",
            title: "text-blue-800",
            message: "text-blue-700",
            button: "bg-blue-500 hover:bg-blue-600"
        }
    };

    const styles = typeStyles[type] || typeStyles.error;

    return (
        <div className={`flex flex-col items-center justify-center p-8 rounded-2xl ${styles.bg} ${styles.border} border ${className}`}>
            <div className={`p-4 rounded-full ${styles.bg} mb-4`}>
                <AlertCircle className={`w-8 h-8 ${styles.icon}`} />
            </div>

            <h3 className={`text-lg font-bold mb-2 ${styles.title}`}>
                {title}
            </h3>

            <p className={`text-center mb-6 max-w-md ${styles.message}`}>
                {message}
            </p>

            {onRetry && (
                <button
                    onClick={onRetry}
                    className={`inline-flex items-center gap-2 px-6 py-3 text-white font-medium rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg ${styles.button}`}
                >
                    <RefreshCw className="w-4 h-4" />
                    Réessayer
                </button>
            )}
        </div>
    );
};

export default ErrorMessage;